export const CRM_OBJECT_BOARD_NAMESPACE = 'CRM_OBJECT_BOARD_';
export const withCrmObjectBoardNamespace = name => {
  return `${CRM_OBJECT_BOARD_NAMESPACE}${name}`;
};